import styled from "@emotion/styled"

const ContentMargins = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0px 10px;
`;


export default ContentMargins;